import { render, staticRenderFns } from "./CuentasHistoricas.vue?vue&type=template&id=4dd1775c"
import script from "./CuentasHistoricas.vue?vue&type=script&lang=js"
export * from "./CuentasHistoricas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports